/** Smooth-scrolls to the element with this id; a no-op when the page has none. */
export function scrollToId(id: string): void {
	document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });
}
